import React, { useState } from "react";
import { useAllSettlements } from "../../hooks/settlements/useAllSettlements";
import DataTable from "../DataTables/DataTable";
import StatusBadge from "../assests/StatusBadge";
import { generateDateQuery } from "../configs/generateDateQuery";
import { formatToDate } from "../configs/formatToDate";
import DateSearchHero from "../heros/DateSearchHero";
import { message, Tooltip } from "antd";
import { Clipboard } from "react-feather";
function SettlementHistory() {
  const [dateQuery, setDatequery] = useState("");
  const { data: settlements, isLoading } = useAllSettlements(dateQuery);
  console.log("Settlements ", settlements);

  const columns = [
    {
      title: "TRANSACTION ID",
      dataIndex: "transaction_id",
      // sorter: (a, b) => a.bookingid.length - b.bookingid.length,
      render: (text) =>
        text ? (
          <div className="d-flex align-items-center gap-2">
            <span
              style={{
                maxWidth: 120,
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              title={text}
            >
              {text?.slice(0, 16)}...
            </span>
            <Tooltip title="Copy Order ID">
              <Clipboard
                size={16}
                style={{ cursor: "pointer", color: "#347D73" }}
                onClick={() => {
                  navigator.clipboard.writeText(text);
                  message.success("Copied to clipboard");
                }}
              />
            </Tooltip>
          </div>
        ) : (
          <div>N/A</div>
        ),
    },
    {
      title: "INITATED BY",
      dataIndex: "",
      render: (item, record) => (
        <div className="d-flex align-items-center">
          {record?.user?.first_name || "N/A"}
        </div>
      ),
      // sorter: (a, b) => a.patientname.length - b.patientname.length,
    },
    {
      title: <div className="text-center">Payment Method</div>,
      dataIndex: "payment_method",
      // sorter: (a, b) => a.type.length - b.type.length,
      render: (item) => (
        <div className="text-center">{item ? item : "unknown"}</div>
      ),
    },
    {
      title: "AMOUNT",
      dataIndex: "amount",
      render: (item) => <div>₹{item}</div>,
      sorter: (a, b) => a.amount - b.amount,
      // render: (item) => <div>₹ {item}</div>,
    },
    {
      title: "SETTLEMENT DATE",
      dataIndex: "updated_at",
      // sorter: (a, b) => a.time.length - b.time.length,
      render: (item) => <div>{formatToDate(item)}</div>,
      sorter: (a, b) => new Date(a.updated_at) - new Date(b.updated_at),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "STATUS",
      dataIndex: "status",
      filters: [
        { text: "completed", value: "completed" },
        { text: "requested", value: "requested" },
        { text: "failed", value: "failed" },
        { text: "rejected", value: "rejected" },

      ],
      onFilter: (value, record) => record.status.startsWith(value),
      filterSearch: true,
      render: (item) => (
        <div>
          <StatusBadge status={item} />
        </div>
      ),
    },
  ];

  const handleDate = (date) => {
    const query = generateDateQuery(date);
    setDatequery(query);
    // setdate(date);
  };

  return (
    <div>
      <div>
        <DateSearchHero
          handleDate={handleDate}
          type="settlement-hostory"
          query={`?${dateQuery}`}
        />
        <DataTable
          columns={columns}
          data={settlements ? settlements : []}
          loading={isLoading}
        />
      </div>
    </div>
  );
}

export default SettlementHistory;
